/*
 *  Module to assist with file downloads in MemberDirect, with special handling for iOS devices.
 */
rs.module("layouts/filedownload",

    [ "layouts/pwa" ],

    function (pwa) {

        // Initialize the module
        function initialize(fileDownloadLinkSelector) {
            // Handle fileDownloadLink clicks
            $(document).onjs("click enterpressed", fileDownloadLinkSelector, function (e) {

                // if this download link is suspended, do not react to the click
                if ($(this).data("suspended")) {
                    return;
                }

                var optionsGetter = $(this).data("getfiledownloadoptions");
                var downloadOptions = null;
                if (optionsGetter) {
                    downloadOptions = Function("link", `return ${optionsGetter}(link);`)(this);
                }

                initiateDownload(this, downloadOptions);
            });      
        }

        // Start the download from the downloadLink
        function initiateDownload(downloadLink, options) {
            var isIOS = (/iPad|iPhone|iPod/.test(navigator.userAgent));
            var fileDownloadUrl;

            // if we have a raw string, just use it as the url
            if (typeof downloadLink === "string") {
                fileDownloadUrl = downloadLink;
            }
            // otherwise assume it's our download link
            else {
                fileDownloadUrl = $(downloadLink).data("filedownloadurl");
            }

            // If running on iOS and in a stand-alone PWA (app window)
            if (isIOS && pwa.isRunningStandAlonePWA()) {
                downloadFileIos(fileDownloadUrl, options);
            }
            else {

                // as long as we have a service worker, we can try to track download 
                if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
                    // change the cursor
                    document.body.classList.add("wait");
                    if (options && options.onstart) {
                        options.onstart();
                    }

                    var messageChannel = new MessageChannel();
                    messageChannel.port1.onmessage = function (response) {
                        document.body.classList.remove("wait");

                        if (options && options.oncomplete) {
                            options.oncomplete(response.status);
                        }
                    }
                    navigator.serviceWorker.controller.postMessage({ action: "trackdownload", downloadUrl: fileDownloadUrl }, [messageChannel.port2]);
                }
                
                window.location = fileDownloadUrl;
            }
        }

        // Handle downloading of documents on iOS safari running as a stand-alone PWA
        // since it doesn't handle window.open, target=_blank, or the ability to open a new window in a manner we need 
        // (e.g., allows navigating backwards, includes done button in stand-alone app window, etc.)
        function downloadFileIos(fileDownloadUrl, options) {
            if (options && options.onstart) {
                options.onstart();
            }

            $.ajax({
                url: fileDownloadUrl,
                method: 'GET',
                xhrFields: {
                    responseType: 'blob'
                }
            }).done(function (data, _, xhr) {

                var responseBlob = data
                var contentDisposition = xhr.getResponseHeader('Content-Disposition');
                var fileName = getFileNameFromResponseHeader(contentDisposition);

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(responseBlob);
                link.download = fileName;
                link.click();

                if (options && options.oncomplete) {
                    options.oncomplete("success");
                }
            }).fail(function () {
                if (options && options.oncomplete) {
                    options.oncomplete("failed");
                }
            });
        }

        // Get the fileName from document response header 
        function getFileNameFromResponseHeader(contentDisposition) {

            var fileName = "download.pdf";
            var fileNameRegex = new RegExp(/^.*filename[^;=\n\*]*=([\'"].*?\2|[^;\n]*)[\n;]?/);

            var matches = fileNameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '');
            }

            return fileName;
        }

        var exports = {
            initialize: initialize,
            initiateDownload: initiateDownload
        };

        return exports;
    }
);